import React from 'react';


class Comparateurs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            comparateurs:false
        }
    }

    componentDidMount() {
        let me = this
        this.props.api.post(
            {action:'get_comparateurs',id:this.props.devis._id.$oid},
            (res)=>{
                me.setState({comparateurs:res.comparateurs})
            }
        )
    }

    renderSection(data,expand) {
        let rows = []
        for ( const field in data ) {
            if (( typeof data[field] === 'string' )||( typeof data[field] === 'number' ))  {
                let displayField = field.replace(
                    /([a-z])([A-Z])/g,
                    '$1 $2'
                )
                rows.push( <div key={field} className="details_entry"><label>{displayField}</label><span>{data[field]}</span></div> )
            } else if (( typeof data[field] === 'object' )&& expand ) {
                if ( isNaN(field) ) {
                    rows.push( <div key={field} className="details_entry"><label>{field}</label></div> )
                }
                rows.push( 
                    this.renderSection(data[field],true)
                )
            }
        }
        return rows
    }

    render() {

        let adminButtons = []
        if ( this.props.api.isAdmin() ) {
            adminButtons.push(
                <a target="_blank" key="logs_tarifs" className="button" href={this.props.api.downloadLogs(this.props.devis._id.$oid,'logs_tarifs')}>Logs tarifs</a>
            )
            if ( this.props.devis.params.nom ) {
                adminButtons.push(
                    <a target="_blank" key="logs_devis" className="button" href={this.props.api.downloadLogs(this.props.devis._id.$oid,'logs_devis')}>Logs devis</a>
                )    
            }
        }

        return <div className="details">
            <div className="details_section"><h2>Véhicule</h2>
            {this.renderSection(this.state.comparateurs.Vehicule,true)}
            </div>
            <div className="details_section"><h2>Conducteur</h2>
            {this.renderSection(this.state.comparateurs.CondPrincipal,true)}
            </div>
            <div className="details_section"><h2>Devis</h2>
            {this.renderSection(this.state.comparateurs,false)}
            </div>
            <div className="details_section">
                {adminButtons}
            </div>
        </div>
    }
}

export default Comparateurs;
